module.exports = __webpack_public_path__ + "img/1ed_timer.c9504feb.svg";